import { fetchApi } from '@/config/axiosSetting';
import { PatchCulpritCertificationQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchCulpritCertification/patchCulpritCertificationQuery.type';

export const patchCulpritCertificationFunction = (
  params: PatchCulpritCertificationQueryParamsType,
) => {
  return fetchApi.patch(
    `property/reports/${params?.id}/accident_users/culprit/user_information/driver/certificate_information/`,
    params?.data,
    {
      params: {
        id: params?.id,
      },
    },
  );
};
